import $ from 'jquery';

import {Analytics} from "@plaudit/analytics";
Analytics.setup({features: {errorTracking: false}}); // This will set up the system and return an instance of Analytics.

function onCheckFormConfirmation() {
	const confirmations = document.querySelectorAll(".analyticsFormConfirmation");
	for (let i=0; i < confirmations.length; i++) {
		const confirmation = confirmations[i];
		if (confirmation !== undefined && confirmation instanceof HTMLElement) {
			// Remove so it is not processed again
			confirmation.remove();

			// Process it
			const formTitle = confirmation.dataset.analyticsFormTitle;
			const formId = confirmation.dataset.analyticsFormId;
			const formType = confirmation.dataset.analyticsFormType;
			const analytics = Analytics.getInstance();
            if (formType === undefined) {
                console.warn("Form type is not defined for form confirmation", confirmation);
            } else {
			    analytics.trackEvent(formType, "Confirmation", `${formTitle} (ID: ${formId})`);
				// 20240816 - (DESK-16210) Adwords tracking
				if (typeof gtag !== 'undefined') {
					gtag('event', 'conversion', {'send_to': 'AW-16568817739/jBF7CMrllb8ZEMuw0Nw9'});
				}
            }
		}
	}
}

$(document).on("gform_confirmation_loaded", onCheckFormConfirmation);
$(document).on("frmFormComplete", onCheckFormConfirmation);
$(onCheckFormConfirmation);
